"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Eyebrow = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var _GithubButton = require("./GithubButton");

var GithubButtonWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eijpdt33"
} : {
  target: "eijpdt33",
  label: "GithubButtonWrapper"
})("margin-left:", _styles.spacing.padding.medium, "px;flex:none;");
var EyebrowLink = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Link, process.env.NODE_ENV === "production" ? {
  target: "eijpdt32"
} : {
  target: "eijpdt32",
  label: "EyebrowLink"
})(_styles.text.storybookMedium, " white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&&{", function (props) {
  return {
    color: props.inverse ? _styles.color.lightest : _styles.color.darker
  };
}, ";}");
var EyebrowCallout = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Link, process.env.NODE_ENV === "production" ? {
  target: "eijpdt31"
} : {
  target: "eijpdt31",
  label: "EyebrowCallout"
})(_styles.text.storybookMedium, " &&{", function (props) {
  return {
    color: props.inverse ? _styles.color.lightest : _styles.color.dark
  };
}, ";}");
var EyebrowContainer = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eijpdt30"
} : {
  target: "eijpdt30",
  label: "EyebrowContainer"
})("position:relative;z-index:20;display:none;align-items:center;padding:", _styles.spacing.padding.small, "px ", _styles.spacing.padding.medium, "px;background-color:", function (props) {
  return props.inverse ? 'rgba(0, 0, 0, 0.1)' : _styles.color.blueLight;
}, ";box-shadow:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : _styles.color.tr10;
}, " 0 -1px 0px 0px inset;", EyebrowLink, "{margin-left:", _styles.spacing.padding.small, "px;margin-right:auto;}", EyebrowCallout, "{display:none;text-align:right;}@media (min-width: ", _styles.breakpoints[0], "px){display:flex;}@media (min-width: ", _styles.breakpoints[2], "px){", EyebrowCallout, "{display:inline-flex;}}");

var Eyebrow = function Eyebrow(_ref) {
  var label = _ref.label,
      link = _ref.link,
      inverse = _ref.inverse,
      githubStarCount = _ref.githubStarCount;
  return /*#__PURE__*/_react["default"].createElement(EyebrowContainer, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Badge, {
    status: "positive"
  }, "New"), /*#__PURE__*/_react["default"].createElement(EyebrowLink, {
    inverse: inverse,
    secondary: !inverse,
    href: link,
    withArrow: true
  }, label), /*#__PURE__*/_react["default"].createElement(EyebrowCallout, {
    inverse: inverse,
    secondary: !inverse,
    href: "https://www.chromatic.com/storybook?utm_source=storybook_website&utm_medium=eyebrow&utm_campaign=storybook"
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    icon: "chromatic",
    "aria-hidden": true
  }), "Visual test with Chromatic"), /*#__PURE__*/_react["default"].createElement(GithubButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_GithubButton.GithubButton, {
    starCount: githubStarCount,
    inverse: inverse
  })));
};

exports.Eyebrow = Eyebrow;